export default __webpack_public_path__ + "static/media/Verve.021da764.svg";